<cst-toolbar>
  @if (add.observers.length !== 0) {
    <ctrl-btn-create (click)="OnAdd()" type="primary"></ctrl-btn-create>
  }
  <form style="margin-left: 20px; font-size: 1rem" [formGroup]="formFilter">
    <frm-check
      formControlName="showArchived"
      i18n-label="@@PlanungAPI_TaskFormulars_Filter_ShowArchived"
      label="Show archived"
    ></frm-check>
  </form>
</cst-toolbar>
<app-list-view
  [dataSource]="dataSource"
  [columns]="columns"
  [actions]="mainActions"
  [elevated]="false"
  [getRowStyle]="getRowStyle"
  expansionMode="multi"
  [canRowExpand]="canRowExpand"
  (rowExpanded)="onRowExpanded($event)"
  id="TaskFormulars"
>
  <ng-template cstListViewDetailTemplate let-formular="item">
    <div style="min-height: 28px">
      <div>
        @if (formular.pdfs()) {
          <table>
            @for (pdfResult of formular.pdfs(); track pdfResult) {
              <tbody>
                <tr>
                  <td style="width: 164px">
                    <ctrl-btn
                      icon="cloud_upload"
                      i18n-title="@@TaskFormularTable_UploadToInfoportal"
                      title="Upload PDF to the Infoportal"
                      [disabled]="!CanUploadPdfToInfoportal()"
                      (click)="OnUploadPdfToInfoportal(pdfResult)"
                    ></ctrl-btn>
                    <ctrl-btn
                      icon="mail"
                      i18n-title="@@TaskFormularTable_SendPerMail"
                      title="Send the PDF via E-Mail"
                      [loading]="isLoadingPdfPerMail"
                      [disabled]="!CanSendPdfPerMail(formular, pdfResult)"
                      (click)="OnSendPdfPerMail(formular, pdfResult)"
                    ></ctrl-btn>
                    <ctrl-btn
                      icon="visibility"
                      i18n-title="Die PDF-Datei anzeigen@@TaskFormularTabelShowPDF"
                      title="Show the PDF-file"
                      (click)="OnDisplayPdf(pdfResult)"
                    ></ctrl-btn>
                    <ctrl-btn
                      icon="file_download"
                      i18n-title="Die PDF-Datei herunterladen@@TaskFormularTabelDownloadPDF"
                      title="Download PDF-file"
                      (click)="OnDownloadPdf(pdfResult)"
                    ></ctrl-btn>
                  </td>
                  <td style="width: 300px">
                    <b>{{ pdfResult.label }}</b>
                  </td>
                  <td class="small">{{ pdfResult.filename }}</td>
                </tr>
              </tbody>
            }
          </table>
        }
        <app-spinner-overlay
          [visible]="formular.isLoadingPdfs()"
        ></app-spinner-overlay>
      </div>
      @if (formular.isDetailOpenedAtLeastOnce) {
        <div style="padding-top: 1em">
          <app-task-formular-images-gallery
            [formID]="formular.id"
          ></app-task-formular-images-gallery>
        </div>
      }
    </div>
  </ng-template>
</app-list-view>
